import { isFunction } from 'lodash';

import { Button } from '@/components/button';
import { Landing } from '@/components/modules/landing';

export interface ShipmentNotFoundProps {
  onBack?: () => void;
}

const ShipmentNotFound = ({ onBack }: ShipmentNotFoundProps) => {
  return (
    <Landing
      heading="We weren't able to find any data for this shipment just yet."
      subHeading=" In some cases it can take a little bit longer to find tracking data. We will keep checking for up to 5 days, so please check back soon."
      imageUrl="https://www.datocms-assets.com/52833/1718339394-shipment-placeholder.png"
      imageAlt="shipment not found"
      variant="basic"
      imageWidth={300}
      order="reverse"
      actions={isFunction(onBack) ? <Button onClick={onBack}>Back to shipments</Button> : null}
    />
  );
};

export { ShipmentNotFound };
